/**
 * Preferencias de ESTE dispositivo (como UserDefaults en iOS). Con prefijo sut- (se borran al cerrar sesión).
 * Lo que debe ser igual en todos los dispositivos (rotación de Wing Chun, bloque…) va en la pestaña Settings.
 */
export interface Prefs {
  countdownEnabled: boolean;
  measureLastRound: boolean;
  celebrationSound: string;   // id de CELEBRATION_SOUNDS
  textScale: number;          // 1 · 1.4 · 1.8
  reminderEnabled: boolean;
  reminderTime: string;       // HH:MM, hora local
}

const KEY = 'sut-prefs';
const DEFAULTS: Prefs = { countdownEnabled: true, measureLastRound: true, celebrationSound: 'levelup', textScale: 1.4, reminderEnabled: false, reminderTime: '08:00' };

export function loadPrefs(): Prefs {
  try {
    return { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<Prefs>) };
  } catch { return { ...DEFAULTS }; }
}

export function savePrefs(p: Partial<Prefs>): Prefs {
  const next = { ...loadPrefs(), ...p };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* sin almacenamiento */ }
  return next;
}

export const CELEBRATION_SOUNDS = [
  { id: 'levelup', name: 'Level up' },
  { id: 'tada', name: 'Tada' },
  { id: 'fanfare', name: 'Fanfarria' },
  { id: 'gamestart', name: 'Game start' },
  { id: 'wow', name: 'Wow' },
  { id: 'none', name: 'Ninguno' },
];
